<div class="modal__content paymentmodal">
    <div  v-if="!paymentCheckout">
        <h1>{{ $t('modals.payment.title') }}</h1>
        <h3>{{ $t('payment.package-choice') }}</h3>
        <div class="packages">
            <div class="packages__tile" v-for="(pack, key) in sortPackages" @click="selectPackage(pack.id)" >
                <div class="payment_wrapper" :class="{ 'selected' : pack.id === selectedPack }">
                    <div class="discount" v-if="getBonusAmount(pack.price) > 0">
                        {{ $filters.bonusPercentage(getBonusAmount(pack.price)) }}
                    </div>
                    <div class="payment_package" >
                        <div class="name" v-t="'payment.packages.pack' + pack.id" :class="{ 'selected' : pack.id === selectedPack, 'gold': pack.id === 4, 'silver': pack.id === 2, 'bronze': pack.id === 1  }"></div>
                        <div class="price">
                            {{ $filters.shortCurrency(pack.price) }}
                        </div>
                        <div class="minutes">
                            {{ Math.floor(pack.minutes) }} minutes
                        </div>
                    </div>
                    <div class="toggle" :class="{ 'selected' : pack.id === selectedPack }" >
                        <div class="toggle_circle"  :class="{ 'selected' : pack.id === selectedPack }" >
                            <i v-if="pack.id === selectedPack" class="fa-solid fa-check"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h3>{{ $t('payment.methods-choice') }}</h3>
        <div class="methods" v-if="getMethods">
            <div class="methode" v-for="paymentMethod in getMethods"
                :class="{ 'active': paymentMethod.abbr === selectedPayment }" v-on:click="selectPayment(paymentMethod.abbr)">    
                <div class="methode_image" :class="paymentMethod.abbr.replace(/\//g, '-')">
                    <span></span>
                </div>
                <div v-if="paymentMethod.abbr === selectedPayment" class="vink">
                    <div class="vink_icon">
                        <i class="fa-solid fa-check"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="action">
            <button class="btn btn-green" @click="isSafari ? doPaymentSafari() : doPayment()">{{ $t('modals.new.next') }}</button>
        </div>
    </div>  
</div>
